<template>
  <article class="slider-item">
    <div class="slider-item__overlay"></div>
    <!-- Desktop video -->
    <video
      playsinline
      paused
      muted
      loop
      :poster="getPoster(slide.medias, 'desktop')"
      class="desktop"
    >
      <source :src="getBgVideo(slide.medias, 'webm', 'desktop')" type="video/webm" />
      <source :src="getBgVideo(slide.medias, 'ogv', 'desktop')" type="video/ogv" />
      <source :src="getBgVideo(slide.medias, 'mp4', 'desktop')" type="video/mp4" />
    </video>

    <!-- Mobile video -->
    <video
      playsinline
      autoplay
      muted
      loop
      :poster="getPoster(slide.medias, 'mobile')"
      class="mobile"
    >
      <source :src="getBgVideo(slide.medias, 'webm', 'mobile')" type="video/webm" />
      <source :src="getBgVideo(slide.medias, 'ogv', 'mobile')" type="video/ogv" />
      <source :src="getBgVideo(slide.medias, 'mp4', 'mobile')" type="video/mp4" />
    </video>

    <!-- Infos -->
    <div class="slider-item__infos">
      <div class="slider-item__infos--left">
        <span class="slider-item__infos--left--client">
          {{ slide.client }} <br />
          {{ slide.year }}
        </span>

        <span class="slider-item__infos--left--country"> {{ slide.regional_name }} </span>
      </div>

      <div class="slider-item__infos--right">
        <a :href="`${slide.link}`" target="_self">
          <span class="slider-item__infos--right--category">
            <!-- {{ slide.category }} -->
          </span>
          <h2 class="slider-item__infos--right--title">{{ slide.title }}</h2>
          <span class="slider-item__infos--right--description">
            {{ slide.description }}
          </span>
          <span class="slider-item__infos--right--see-more">
            {{ $tc("generals.seework") }}
          </span>
        </a>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  name: "home-slider-item",
  computed: {
    slide() {
      return this.data || {};
    },
  },

  methods: {
    getBgVideo(medias, extension, resolution) {
      return medias.videos[resolution][extension];
    },

    getPoster(medias, resolution) {
      return medias.images[resolution];
    },
  },
};
</script>

<style lang="scss">
@import "./styles/home-slider-item";
</style>
